import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentItemApi from '../../../aiContentItem.api';
import {CreateMultipleAiContentItemsRequest} from '../../../aiContentItem.types';
import {setItems, setItemsError, setItemsLoading} from '../aiContentProject.slice';

interface CreateMultipleAiContentItemsParams {
  projectId: number;
  request: CreateMultipleAiContentItemsRequest;
}

const createMultipleAiContentItems = createAsyncThunk<
  void,
  CreateMultipleAiContentItemsParams,
  {state: RootState}
>(
  `${BreadcrumbName.AiContentProjectPage}/createMultipleAiContentItems`,
  async ({projectId, request}, {dispatch, rejectWithValue}) => {
    dispatch(setItemsLoading(true));
    dispatch(setItemsError(null));

    try {
      await aiContentItemApi.createMultipleAiContentItems(request);

      // Reload all items from API to ensure data consistency
      const items = await aiContentItemApi.getAiContentItemsByProjectId(projectId);
      dispatch(setItems(items));
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to create items';
      dispatch(setItemsError(errorMessage));

      return rejectWithValue(errorMessage);
    } finally {
      dispatch(setItemsLoading(false));
    }
  },
);

export default createMultipleAiContentItems;
